import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';

import {
  NbDialogRef,
  NbStepperComponent
} from '@nebular/theme';

import {
  Discount,
  Ratios,
  Pricelist,
  RatiosWms
} from '../../models';

import {
  PricelistService,
  PricelistWmsService
} from '../../providers';

import {
  isArrayNotEmpty,
  isStringSafe
} from '../../app/app.utils';

import {
  DEFAULT_CURRENCY_CODE
} from '../../app/app.const';

import {
  Router
} from '@angular/router';

@Component({
  selector: 'biz-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: [
    './dialog.component.scss'
  ]
})
export class DialogComponent implements AfterViewInit {
  @HostListener(
    'document:click',
    [
      '$event'
    ]
  ) handleCheckboxClick(
    event: MouseEvent
  ) {
    if (!this.discountStepper) {
      return false;
    }

    if (
      (
        (
          <HTMLElement>(
            event
              .target
          )
        )
      ) &&
      (
        (
          <HTMLElement>(
            event
              .target
          )
        )
        .className
      ) &&
      (
        (
          (
            <HTMLElement>(
              event
                .target
            )
          )
          .className
        ) ===
        'label'
      ) &&
      (
        (
          <HTMLElement>(
            event
              .target
          )
        )
        .childNodes
      ) &&
      (
        (
          <HTMLElement>(
            event
              .target
          )
        )
        .childNodes[0]
      ) &&
      (
        (
          (
            <HTMLElement>(
              (
                <HTMLElement>(
                  event
                    .target
                )
              )
              .childNodes[0]
            )
          )
          .getAttribute(
            'type'
          )
        ) ===
        'checkbox'
      )
    ) {
      (
        <HTMLElement>(
          event
            .target
        )
      )
      .parentElement
      .parentElement
      .parentElement
      .parentElement
      .classList
      .toggle(
        'disabled'
      );
    }
  }

  @ViewChild(
    'discountStepper',
    {
      read: NbStepperComponent
    }
  ) discountStepper: NbStepperComponent;

  @ViewChildren(
    'discountCheckbox',{
      read: ElementRef
    }
  ) discountCheckboxes: QueryList<ElementRef>;

  @Input('type')
  public type: string;

  @Input('pricelist')
  public pricelist: any;

  @Input('pricelistDomain')
  public pricelistDomain: string;

  public discountDefaults: Discount[];
  public discountDefaultsOffIndexes: number[] = [
    1,
    2,
    3,
    5
  ];

  public discountRatioMap: Ratios | RatiosWms;
  public markupRatioMap: Ratios  | RatiosWms;
  public markupCostsRatioMap: Ratios  | RatiosWms;
  
  public pageDomain: string = null;
  
  private pricelistServiceDomain;


  ngOnInit() {}

  constructor(
    private router: Router,
    private pricelistWmsService: PricelistWmsService,
    private dialogRef: NbDialogRef<DialogComponent>,
    private pricelistService: PricelistService
  ) {
    this.setPageDomain();

    this.discountDefaults = [
      ...(
        this.pricelistServiceDomain
            .discountDefaults
      )
    ];

    this.discountRatioMap = (
      this.pricelistServiceDomain
          .cloneDiscountRatioMap
    );

    this.markupCostsRatioMap = (
      this.pricelistServiceDomain
          .markupCostsRatioMap
    );

    this.markupRatioMap = (
      this.pricelistServiceDomain
          .markupRatioMap
    );
  }

  public ngAfterViewInit() {
    const discountCheckboxes = (
      this.discountCheckboxes
          .toArray()
          .filter(
            discountCheckbox => (
              !!(
                discountCheckbox
                  .nativeElement
              )
            )
          )
    );

    if (
      isArrayNotEmpty(
        discountCheckboxes
      )
    ) {
      this.discountDefaultsOffIndexes
          .forEach(
            discountOffIndex => (
              discountCheckboxes[
                discountOffIndex
              ]
              .nativeElement
              .parentElement
              .parentElement
              .parentElement
              .classList
              .add(
                'disabled'
              )
            )
          );
    }
  }

  public get pageDomainModelName() {
    return (
      (
        (
          isStringSafe(
            this.pricelistDomain
          )
        ) &&
        (
          this.pricelistDomain
            .startsWith(
              'costs'
            )
        )
      ) ?
        'Cost List' :
        'Pricelist'
    );
  }

  public get pricelistHasCurrencyCodeDefault() {
    return (
      this.pricelist &&
      (
        (
          this.pricelist
              .currencyCode
        ) ===
        DEFAULT_CURRENCY_CODE
      )
    );
  }

  public isDiscountOn(
    index
  ) {
    return (
      !(
        this.discountDefaultsOffIndexes
            .includes(
              index
            )
      )
    );
  }

  public onConfirm() {
    this.dialogRef
        .close({
          confirm: true,
          type: this.type,
          ...(
            (
              this.type ===
              'clone'
            ) ?
              {
                discountRatioMap: (
                  this.discountRatioMap
                )
              } :
              {}
          ),
          ...(
            (
              this.type ===
              'clone-costs'
            ) ?
              {
                markupCostsRatioMap: (
                  this.markupCostsRatioMap
                )
              } :
              {}
          ),
          ...(
            (
              this.type ===
              'generate'
            ) ?
              {
                discountDefaults: (
                  this.discountDefaults
                      .filter(
                        (
                          discountEach,
                          index
                        ) => (
                          !(
                            this.discountDefaultsOffIndexes
                                .includes(
                                  index
                                )
                          )
                        )
                      )
                )
              } :
              {}
          ),
          ...(
            (
              this.type ===
              'markup'
            ) ?
              {
                markupRatioMap: {
                  ...this.markupRatioMap,
                  currencyCode: (
                    this.pricelist
                        .currencyCode
                  ),
                  currencyRate: (
                    this.pricelistHasCurrencyCodeDefault ?
                      (
                        this.pricelist
                            .rateCurrency
                      ) :
                      undefined
                  )
                }
              } :
              {}
          )
        });
  }

  public onClose() {
    this.dialogRef
        .close({
          confirm: false,
          type: this.type
        });
  }

  public onToggleDiscountDefault(
    index: number
  ) {
    const discountOffIndex = (
      this.discountDefaultsOffIndexes
          .indexOf(
            index
          )
    );

    if (
      discountOffIndex >
      -1
    ) {
      this.discountDefaultsOffIndexes
          .splice(
            discountOffIndex,
            1
          );
    }
    else {
      this.discountDefaultsOffIndexes
          .push(
            index
          );
    }
  }

  public get isWms() {
    return (
      (
        isStringSafe(
          this.pageDomain
        )
      ) &&
      (
        this.pageDomain
            .endsWith(
              'wms'
            )
      )
    );
  }

  private setPageDomain() {
    const isWms = (
      this.router
          .url
          .startsWith(
            '/wms'
          )
    );

    this.pageDomain = (
      (
        this.router
            .url
            .includes(
              '/cost-lists'
            )
      ) ?
        (
          isWms ?
            'costs-wms' :
            'costs'
        ) :
        (
          isWms ?
            'wms' :
            null
        )
    );

    this.pricelistServiceDomain = (
      this.isWms ?
        this.pricelistWmsService :
        this.pricelistService
    );
  }
}
